import { render, staticRenderFns } from "./highchartIndustry.vue?vue&type=template&id=2c568c69&"
import script from "./highchartIndustry.vue?vue&type=script&lang=js&"
export * from "./highchartIndustry.vue?vue&type=script&lang=js&"
import style0 from "./highchartIndustry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports